import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { canOpen, homePath } from '../../lib/access/screenAccess';
import { useMyAccess } from '../../hooks/useMyAccess';
import { ScreenClosedNotice } from './AccessCards';

/**
 * The screen of `/admin` shown only when the person's access opens it (lot L6g, `canOpen`); otherwise a notice inside
 * the layout, with the way back to their home. `ProtectedRoute` has already waited for the access to be read.
 */
export function ScreenGate({ children }: { readonly children: ReactNode }) {
  const { pathname } = useLocation();
  const { state } = useMyAccess();
  if (state.status !== 'ready') return null;
  // `/admin` itself is the redirect to the person's home (HomeRedirect).
  const isRoot = pathname.replace(/\/+$/, '') === '/admin';
  if (!isRoot && !canOpen(pathname, state.access)) return <ScreenClosedNotice home={homePath(state.access)} />;
  return <>{children}</>;
}

/** `/admin` itself: the person's home, the Bureau for an administrator, the CRM for a commercial. */
export function HomeRedirect() {
  const { state } = useMyAccess();
  if (state.status !== 'ready') return null;
  const home = homePath(state.access);
  return home === null ? <ScreenClosedNotice home={null} /> : <Navigate to={home} replace />;
}
